import React, {Component} from 'react';
import {connect} from 'react-redux';
import PersonsManagement from './personsList';
import * as actions from '../../actions';
import {toJS} from "../hocs/toJs";
import {formValueSelector} from "redux-form/immutable";

const selector = formValueSelector('sortPersonsForm');

const parseDepartments = (department) => {
  const parsedDepartments = [];
  department.valueSeq().toArray().forEach( department => (
    parsedDepartments.push({
      id: department.get('id'),
      name: department.get('name'),
      weightOld: department.get('weightOld'),
      weightNew: department.get('weightNew'),
      weightNewComing: department.get('weightNewComing'),
      createdDate: department.get('createdDate'),
    })));
  return parsedDepartments;
};

const parsePersons = (persons) => {
  const parsedPersons = [];
  persons.valueSeq().toArray().forEach(person => (
    parsedPersons.push({
      id: person.get('id'),
      username: person.get('username'),
      email: person.get('email'),
      roles: person.get('roles').valueSeq().toArray().map( role => ({
        id: role.get('id'),
        name: role.get('name')
      })),
      department: person.get('department')?{
        id: person.getIn(['department', 'id']),
        name: person.getIn(['department', 'name']),
      }:{}
    })));
  return parsedPersons;
};

class PersonsManagementHOC extends Component {

  componentDidMount() {
    this.props.getPersons({filter: {include:
          [
            'roles',
            'department',
            {
              relation: 'scoreRecords',
              scope: {
                include: [
                  'department',
                  {
                    relation: 'scores',
                    scope: {
                      include: 'store',
                      limit: 1
                    }
                  }
                ]
              }
            }
          ]
    }});
    this.props.getDepartments({filter:{where: {or: [{deleted: false}, {deleted: null}]}}});
  }

  _getScoreRecordType = (scoreRecord) => {
    try {
      if(scoreRecord.scores[0].store.old) {return 'Εξάμηνη'}
      if(scoreRecord.scores[0].store.newComing) {return 'Υφιστάμενη'}
      if(scoreRecord.scores[0].store.new) {return 'Νέα'}
    } catch (e) {
      return ''
    }
  };

  render(){
    return (
      <PersonsManagement
        {...this.props}
        _getScoreRecordType={this._getScoreRecordType}
      />
    )
  }
}

const mapStateToProps = (state) => {
  return {
    departments: state.departments.get('departments'),
    persons: state.persons.get('persons'),
    loading: state.persons.get('fetching'),
    mobileViewSortBy: selector(state, 'sortBy'),
    mobileViewSortOrder: selector(state, 'sortOrder'),
    loggedInPersonId: state.loggedInPerson.get('id'),
    deletingPerson: state.person.get('deleting'),
    deletePersonResponseMessage: state.person.get('message')
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    getPersons: (payload) => {
      dispatch(actions.getPersons(payload))
    },
    getDepartments: (payload) => {
      dispatch(actions.getDepartments(payload))
    },
    deletePerson: (payload) => {
      dispatch(actions.deletePerson(payload))
    },
    changePersonState: (payload) => {
      dispatch(actions.changePersonState(payload))
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(toJS(PersonsManagementHOC));



// WEBPACK FOOTER //
// ./src/components/personsList/personsListHOC.js